import request from './request'
//import Vue from 'vue'

export default class AutomationsApi {
  async api_getAutomations() {
    return await request(
      {
        environment: '/automations',
        type: 'query',
        name: 'getAutomations',
        way: './graphql/automation/query/',
        has_catch: true
      }
    )
  }
  async api_getAutomation(automationId) {
    return await request(
      {
        environment: '/automations',
        type: 'query',
        name: 'getAutomation',
        variables: {automationId},
        way: './graphql/automation/query/',
        has_catch: true}
    )
  }
  async api_getAutomationLogs(model) {
    const tenderId = model?.tenderId ? +model.tenderId : null

    return await request(
      {
        environment: '/automations',
        type: 'query',
        name: 'automationLogs',
        variables: {...model, tenderId},
        way: './graphql/automation/query/',
        has_catch: true}
    )
  }
  async api_createAutomation(automationData) {
    return await request(
      {
        environment: '/automations',
        type: 'mutation',
        name: 'createAutomation',
        variables: {automationData: automationData},
        way: './graphql/automation/mutations/'
      }
    )
  }
  async api_updateAutomation(automationData) {
    return await request(
      {
        environment: '/automations',
        type: 'mutation',
        name: 'updateAutomation',
        variables: {automationData: automationData},
        way: './graphql/automation/mutations/'
      }
    )
  }
  async api_deleteAutomation(automationId) {
    return await request(
      {
        environment: '/automations',
        type: 'mutation',
        name: 'deleteAutomation',
        variables: automationId,
        way: './graphql/automation/mutations/'
      }
    )
  }
}